import { Outlet } from 'react-router-dom';
import { Header as MainHeader } from './MainHeader';
import { Footer } from './Footer';
import { WhatsAppButton } from './WhatsAppButton';
import { Toaster } from './ui/sonner';

export const Layout = () => {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      {/* Aqui era o erro: o nome tem que ser igual ao do import ali em cima */}
      <MainHeader /> 
      
      <main className="pt-16 lg:pt-20">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="top-right" />
    </div>
  );
};
